import { render } from "./Debug.vue?vue&type=template&id=17dfba6c"
import script from "./Debug.vue?vue&type=script&lang=js"
export * from "./Debug.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__